import { apiGet } from "@redriver/cinnamon";

export const getDocumentRecipients = (params) => {
  return apiGet(
    "ActionTypes.GetDocumentRecipients",
    `sheets/${params.sheetId}/document-recipients`,
  );
};
